import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { StrategySettings } from 'crono-fe-common/types/strategySettings';

export default function useGetStrategySettings(strategyId?: number | null) {
  const request: Request = {
    url: `${ENDPOINTS.strategySettings.main}?strategyId=${strategyId}`,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.strategySettings.main, strategyId],
    queryFn: () => client(request),
    staleTime: 30 * 60 * 1000,
    enabled: Boolean(strategyId && strategyId > 0),
  };

  const { data, ...rest } = useQuery<Response<StrategySettings>, CronoError>(
    requestConfig,
  );

  return { data, ...rest };
}
